module.exports = __webpack_public_path__ + "static/media/ro.2c40bbbb.jpeg";